import Avatar from '@atlaskit/avatar/Avatar';
import type { AddFlagProps } from '@databases/flags-types';
import React from 'react';

import { type ContentTypesFlagProps } from '@canvas/frame-api-types';

import { BaseMentionBuilder } from './baseMentionBuilder.ts';
import { messages } from './i18n.ts';
import { type MentionBuilder } from './types.ts';

export class RestrictionsFlagForSingleUser
  extends BaseMentionBuilder
  implements MentionBuilder
{
  shouldShowFlag(): boolean {
    return this.usersWithoutAccess.length === 1;
  }
  build(): AddFlagProps & ContentTypesFlagProps {
    const { permissions, profilePicture, displayName } = this.usersWithoutAccess[0];

    if (permissions.isSpaceRestricted) {
      return {
        id: `restrictions-flag-for-single-user-${this.contentId}`,
        type: 'custom',
        iconString: 'avatar',
        profilePicture,
        icon: () => <Avatar src={profilePicture} label="" />,
        title: this.formatMessage(
          messages['mention-notification.flag-permission-restriction-title-one-user'],
          {
            displayName
          }
        ),
        description: this.formatMessage(
          messages['mention-notification.flag-permission-space-restriction-description']
        )
      };
    } else if (permissions.isParentDatabaseRestricted) {
      return {
        id: `restrictions-flag-for-single-user-${this.contentId}`,
        type: 'custom',
        iconString: 'avatar',
        profilePicture,
        icon: () => <Avatar src={profilePicture} label="" />,
        title: this.formatMessage(
          messages['mention-notification.flag-permission-restriction-title-one-user'],
          {
            displayName
          }
        ),
        description: this.formatMessage(
          messages['mention-notification.flag-permission-parent-restriction-description']
        )
      };
    } else {
      return {
        id: `restrictions-flag-for-single-user-${this.contentId}`,
        type: 'custom',
        iconString: 'avatar',
        profilePicture,
        icon: () => <Avatar src={profilePicture} label="" />,
        title: this.formatMessage(
          messages['mention-notification.flag-permission-restriction-title-one-user'],
          {
            displayName
          }
        ),
        description: this.formatMessage(
          messages['mention-notification.flag-permission-restriction-description']
        )
      };
    }
  }
}
